import React, { useCallback, useEffect, useState, useRef } from 'react';
import { X, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type Notification = {
  name: string;
  city: string;
  product: string;
  time: string;
};
const NOTIFICATIONS: Notification[] = [{
  name: 'Claudia G.',
  city: 'Tucumán',
  product: 'MegaPack Agente Pro',
  time: 'hace 2 minutos'
}, {
  name: 'Martín F.',
  city: 'Rosario',
  product: 'MegaPack Agente Pro MAX',
  time: 'hace 5 minutos'
}, {
  name: 'Lucía R.',
  city: 'Córdoba',
  product: 'MegaPack Agente Pro',
  time: 'hace 8 minutos'
}, {
  name: 'Diego S.',
  city: 'Mendoza',
  product: 'MegaPack Agente Pro MAX',
  time: 'hace 1 minuto'
}, {
  name: 'Valentina P.',
  city: 'La Plata',
  product: 'MegaPack Agente Pro',
  time: 'hace 12 minutos'
}, {
  name: 'Joaquín M.',
  city: 'Salta',
  product: 'MegaPack Agente Pro',
  time: 'hace 4 minutos'
}, {
  name: 'Sofía L.',
  city: 'Mar del Plata',
  product: 'MegaPack Agente Pro',
  time: 'hace 3 minutos'
}, {
  name: 'Tomás B.',
  city: 'Neuquén',
  product: 'MegaPack Agente Pro MAX',
  time: 'hace 7 minutos'
}];
const VISIBLE_MS = 5000;
const randomGap = () => 25000 + Math.random() * 10000; // 25–35s
export function SocialProofPopup() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const [closed, setClosed] = useState(false);
  const lastIndex = useRef(-1);
  const hideTimer = useRef<ReturnType<typeof setTimeout>>();
  const nextTimer = useRef<ReturnType<typeof setTimeout>>();
  const pickNext = useCallback(() => {
    let idx = Math.floor(Math.random() * NOTIFICATIONS.length);
    if (idx === lastIndex.current) idx = (idx + 1) % NOTIFICATIONS.length;
    lastIndex.current = idx;
    return NOTIFICATIONS[idx];
  }, []);
  const showCycle = useCallback(() => {
    setCurrent(pickNext());
    hideTimer.current = setTimeout(() => {
      setCurrent(null);
      nextTimer.current = setTimeout(showCycle, randomGap());
    }, VISIBLE_MS);
  }, [pickNext]);
  useEffect(() => {
    const first = setTimeout(showCycle, 4000); // small initial delay
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer.current);
      clearTimeout(nextTimer.current);
    };
  }, [showCycle]);
  const handleClose = () => {
    setClosed(true);
    setCurrent(null);
    clearTimeout(hideTimer.current);
    clearTimeout(nextTimer.current);
  };
  if (closed) return null;
  return <div className="fixed bottom-5 left-5 z-[60] pointer-events-none" data-id="element-275">
      <AnimatePresence data-id="element-276">
        {current && <motion.div key={current.name + current.time} initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 28
      }} className="pointer-events-auto w-[300px] max-w-[calc(100vw-2.5rem)] bg-white rounded-2xl border-[1.5px] border-blue-200 shadow-soft p-4" role="status" aria-live="polite" data-id="element-277">
            <div className="flex items-center justify-between mb-2" data-id="element-278">
              <div className="flex items-center gap-2" data-id="element-279">
                <span className="relative flex h-2.5 w-2.5" data-id="element-280">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-brand-green opacity-60 animate-ping" data-id="element-281" />
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-green" data-id="element-282" />
                </span>
                <span className="flex items-center gap-1 text-[12px] font-bold uppercase tracking-wide text-brand-accent" data-id="element-283">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-284" />
                  Compra verificada
                </span>
              </div>
              <button onClick={handleClose} aria-label="Cerrar notificación" className="text-gray-400 hover:text-brand-navy transition-colors" data-id="element-285">
                <X className="w-4 h-4" data-id="element-286" />
              </button>
            </div>

            <p className="text-brand-navy font-bold leading-snug" data-id="element-287">
              {current.name}{' '}
              <span className="font-normal text-brand-navy/80" data-id="element-288">
                de {current.city}
              </span>
            </p>

            <p className="text-brand-navy text-sm mt-0.5" data-id="element-289">
              compró{' '}
              <span className="font-bold text-brand-accent" data-id="element-290">
                {current.product}
              </span>{' '}
              <span aria-hidden="true" data-id="element-291">🇦🇷</span>
            </p>

            <p className="text-[12px] text-gray-400 mt-1" data-id="element-292">{current.time}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}